import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../store';
import { CollapseFilterProps } from './props';
import { Container } from './styles';

const CollapseFilter: React.FC<CollapseFilterProps> = ({
  children,
  filter,
  pagination,
  sorter,
  loadRequest,
  saveFilter,
  saveLocalStorage,
}) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    if (
      !localStorage.getItem(saveLocalStorage) &&
      !localStorage.getItem(window.location.pathname + `valuesFilter`) &&
      pagination === 1
    ) {
      // dispatch(loadRequest(cddAtivo?.codCdd, inscricaoAtiva, sorter));
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codCdd
        )
      );
    } else if (localStorage.getItem(window.location.pathname + `valuesFilter`) && filter) {
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codCdd,
          sorter
        )
      );
    }
    saveFilter && dispatch(saveFilter(filter));
  }, [
    cddAtivo?.codCdd,
    dispatch,
    filter,
    inscricaoAtiva,
    loadRequest,
    // pagination,
    saveFilter,
    saveLocalStorage,
    sorter,
  ]);

  return (
    <Container defaultActiveKey={['0']} expandIconPosition="right">
      {children}
    </Container>
  );
};

export default CollapseFilter;
